import React from 'react';
import { useLang } from '@/i18n/LanguageContext';
import PageContainer from '@/components/PageContainer';
import PageHeader from '@/components/PageHeader';
import { Key, Scale } from 'lucide-react';

export default function Competences() {
  const { t } = useLang();
  const c = t.competences;

  return (
    <PageContainer>
      <PageHeader kicker={c.kicker} title={c.title} />

      {/* Conseil */}
      <section className="mt-12 animate-fade-up" data-testid="section-conseil">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-11 h-11 flex items-center justify-center bg-navy text-[var(--color-gold)]">
            <Key size={20} />
          </div>
          <h2 className="font-display text-3xl md:text-4xl text-navy">{c.conseilTitle}</h2>
        </div>
        <p className="text-navy/75 text-lg leading-relaxed mb-8 text-justify">{c.conseilIntro}</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {c.conseilItems.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 bg-white p-5 border-l-2 border-[var(--color-gold)] hover:shadow-md transition-shadow"
            >
              <span className="font-display text-2xl text-[var(--color-gold)] leading-none mt-1">
                {String(i + 1).padStart(2, '0')}
              </span>
              <p className="text-navy/85 text-[15px] leading-relaxed">{item}</p>
            </div>
          ))}
        </div>
      </section>

      {/* Contentieux */}
      <section className="mt-20 animate-fade-up" data-testid="section-contentieux">
        <div className="flex items-center gap-4 mb-6">
          <div className="w-11 h-11 flex items-center justify-center bg-navy text-[var(--color-gold)]">
            <Scale size={20} />
          </div>
          <h2 className="font-display text-3xl md:text-4xl text-navy">{c.contentieuxTitle}</h2>
        </div>
        <p className="text-navy/75 text-lg leading-relaxed mb-8 text-justify">{c.contentieuxIntro}</p>

        <div className="grid grid-cols-1 md:grid-cols-2 gap-4">
          {c.contentieuxItems.map((item, i) => (
            <div
              key={i}
              className="flex items-start gap-4 bg-white p-5 border-l-2 border-[var(--color-gold)] hover:shadow-md transition-shadow"
            >
              <span className="font-display text-2xl text-[var(--color-gold)] leading-none mt-1">
                {String(i + 1).padStart(2, '0')}
              </span>
              <p className="text-navy/85 text-[15px] leading-relaxed">{item}</p>
            </div>
          ))}
        </div>
      </section>
    </PageContainer>
  );
}
